import React from "react";
import { PageMode } from "utils/constant";
import TableComponent from "./components/Table";
import FormComponent from "./components/Form";

const DataFaskesRujukan = ({ pageMode, changeMode, isBkk }) => {
  const handlePageModeChange = (page) => {
    changeMode(page);
  };

  return (
    <>
      {pageMode === PageMode.view && (
        <TableComponent
          handlePageModeChange={handlePageModeChange}
          isBkk={isBkk}
        />
      )}
      {pageMode === PageMode.edit && (
        <FormComponent
          handlePageModeChange={handlePageModeChange}
          pageMode={pageMode}
          isBkk={isBkk}
        />
      )}
    </>
  );
};

export default DataFaskesRujukan;
